import { useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import "./TanSelector.css";

// Selectable tan-shade scroller. Orientation follows `layout`:
//   'auto'       horizontal row on mobile, vertical column on tablet+
//   'horizontal' always a row (overlay use)
//   'vertical'   always a column (side panel use)
const TanSelector = ({ circleColors, selectedLevel, setSelectedLevel, showRapid, layout = "auto" }) => {
  const scrollRef = useRef();
  const [localSelected, setLocalSelected] = useState(selectedLevel);
  const { events } = useDraggable(scrollRef);

  const select = (level) => {
    setLocalSelected(level);
    setSelectedLevel(level);
  };

  // Selection ring + number colour scale with the shade depth — genuinely
  // per-circle dynamic values, so they stay inline.
  const accent = (pct) => `color-mix(in srgb, var(--new-yellow) ${pct}%, rgb(255, 248, 233))`;
  const dynamicStyle = (level, backgroundColor) => {
    const pct = Math.min(100, Math.ceil((level / 12) * 100));
    return {
      backgroundColor,
      border: localSelected === level ? `3px solid ${accent(pct)}` : "",
      color: accent(pct),
    };
  };

  return (
    <div
      {...events}
      ref={scrollRef}
      draggable={false}
      className={`tan-selector tan-selector--${layout}`}
    >
      {circleColors.map((color, i) => {
        const level = i + 1;
        return (
          <div
            key={i}
            draggable={false}
            className={`tan-selector__circle${localSelected === level ? " is-selected" : ""}`}
            onClick={(e) => { e.preventDefault(); select(level); }}
            style={dynamicStyle(level, color)}
          >
            <span className="circle-number noselect">{level}</span>
          </div>
        );
      })}
      {showRapid && (
        <div
          key={13}
          draggable={false}
          className={`tan-selector__circle${localSelected === 13 ? " is-selected" : ""}`}
          onClick={(e) => { e.preventDefault(); select(13); }}
          style={dynamicStyle(13, "var(--new-unity-blue)")}
        >
          <span className="circle-number noselect">Rapid</span>
        </div>
      )}
    </div>
  );
};

export default TanSelector;
